import { createSlice } from '@reduxjs/toolkit';
import { findAdminAnalytics } from './api';
import { initialState } from './api/interface';

const adminAnalyticsSlice = createSlice({
  name: 'adminAnalytics',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(findAdminAnalytics.pending, (state) => {
      state.isLoading = true;
      state.status = 'pending';
    });
    builder.addCase(findAdminAnalytics.fulfilled, (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
      state.status = 'succeeded';
    });
    builder.addCase(findAdminAnalytics.rejected, (state) => {
      state.data = null;
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.status = 'failed';
    });
  },
});

export const { reset } = adminAnalyticsSlice.actions;
export default adminAnalyticsSlice.reducer;
